export default {
  data() {
    return {
      guestCallback: null,
      isLoginPromptModalOpen: false,
    };
  },

  methods: {
    continueAsGuest(callback) {
      if(typeof callback === 'function') {
        callback();
      }

      if(typeof this.guestCallback === 'function') {
        this.guestCallback();
      }
    },

    promptLogin(guestCallback) {
      if(typeof guestCallback === 'function') {
        this.guestCallback = guestCallback;
      }

      if(window.sessionStorage) {
        if(
          window.sessionStorage.getItem('loginPrompted')
          && typeof this.guestCallback === 'function'
        ) {
          this.guestCallback();
          return;
        }

        window.sessionStorage.setItem('loginPrompted', true);
      }

      this.isLoginPromptModalOpen = true;
    },
  },
}
